var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChoose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.44594 9.99966L1.60894 12.449C1.35227 12.7912 1.22333 13.2123 1.24442 13.6395C1.26551 14.0667 1.43532 14.4731 1.72444 14.7883L5.1931 18.5723C5.5396 18.9509 6.0291 19.1663 6.54335 19.1663H10.7793C12.9793 19.1663 14.4459 17.333 14.4459 15.4997V7.64291C14.4459 5.54741 11.6959 5.54741 11.6959 7.64291V8.16633",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6963 8.16634V6.59517C11.6963 4.49967 8.94629 4.49967 8.94629 6.59517V8.16634V5.87467C8.94629 3.77917 6.19629 3.77917 6.19629 5.87467V8.16634V2.20709C6.19605 1.84258 6.05107 1.49308 5.79324 1.23541C5.5354 0.977748 5.1858 0.833008 4.82129 0.833008C4.45662 0.833008 4.10688 0.977874 3.84902 1.23574C3.59115 1.4936 3.44629 1.84334 3.44629 2.20801V12.7497",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoose);
export default __webpack_public_path__ + "static/media/choose.7ed79c065b2a3adef1ec318925ed11d9.svg";
export { ForwardRef as ReactComponent };